/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
// @flow
import React from 'react';
import {CHEVRON_RIGHT__16} from '@homeaway/svg-defs';
import {SVGIcon} from '@homeaway/react-svg';
import {Link} from '@homeaway/react-localization-components';
import {FormattedMessage} from 'react-intl';
import {trigger as edapTrigger} from '../../../../utils/edapWrapper';

import './SeeAllCard.less';

type Props = {
    aspectRatio: '16x9' | '3x2' | '4x3' | '1x1' | '3x4',
    seeMoreUrl?: string
};

const SeeAllCard = (props: Props) => {
    const {aspectRatio, seeMoreUrl} = props;

    const onClick = () => {
        edapTrigger('generic.event', {
            eventcategory: 'serp page',
            eventaction: 'see.more.amenitycarousel.card.click'
        });
    };

    return (
        <div className={'PropertyCard PropertyCard__see-all-card'}>
            {
                <div className="PropertyCard__info">
                    <Link
                        className="PropertyCard__anchor"
                        href={seeMoreUrl}
                        onClick={onClick}
                    >
                        <div className="AspectRatioCard">
                            <div
                                className={`AspectRatioCard__top AspectRatioCard__top--${aspectRatio}`}
                            >
                                <div className="AspectRatioCard__figure">
                                    <div className="SeeAllContainer">
                                        <div className="SeeAllContainer__inner-wrapper">
                                            <div className="SeeAllContainer__see-all-text">
                                                <FormattedMessage
                                                    id="seeAll"
                                                    description="see all label"
                                                    defaultMessage="See all"
                                                />
                                            </div>
                                            <div className="SeeAllContainer__icon-wrapper">
                                                <SVGIcon
                                                    markup={CHEVRON_RIGHT__16}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
            }
        </div>
    );
};

export default SeeAllCard;
